export const COUPON_CODE_50_YEARLY = 'STARTSELLING';

export const WIX_PAYMENT_PROVIDER_ID = 'com.wix.wixpay.us';

export const PAYMENT_ACCEPTED_COUNTRIES = [
  'AT',
  'BE',
  'BR',
  'CA',
  'CH',
  'DE',
  'ES',
  'FI',
  'GB',
  'IE',
  'IT',
  'LT',
  'NL',
  'PT',
  'US',
];
